(function ($) {
    "use strict";

    var storage = window.localStorage; // For Newsletter Modal
    $(document).ready(function () {

        // Godaddy Siteseal responsive img
        $('#siteseal img').addClass('img-fluid');

        // Preloader
        $('#preloader').delay(350).fadeOut('slow');

        // Departments menu button
        $('.departments-menu-button').on('click', function (event) {
            event.preventDefault();

            const dropdown = $(this).closest('.departments-container');

            if (dropdown.is('.open')) {
                dropdown.removeClass('open');
            } else {
                dropdown.addClass('open');
            }
        });

        $(document).on('click', function (event) {
            $('.departments-container')
                .not($(event.target).closest('.departments-container'))
                .removeClass('open');
        });


        // magnificPopup ajax view
        $(document).on('mouseenter', '.category-card-deck .card', function (event) {
            event.preventDefault();
            let card = $(this);

            card.addClass('border-primary');
            card.find('.card-footer').addClass('bg-primary');
            card.find('.card-footer h3').addClass('text-white');
        }).on('mouseleave', '.category-card-deck .card', function (event) {
            event.preventDefault();
            let card = $(this);

            card.removeClass('border-primary');
            card.find('.card-footer').removeClass('bg-primary');
            card.find('.card-footer h3').removeClass('text-white');
        });

        // Shopping Cart menu button
        $('.shopping-cart-button').on('click', function (event) {
            event.preventDefault();

            const dropdown = $(this).closest('.shopping-cart-widget');

            if (dropdown.is('.open')) {
                dropdown.removeClass('open');
            } else {
                dropdown.addClass('open');
            }
        });

        $(document).on('click', function (event) {
            $('.shopping-cart-widget')
                .not($(event.target).closest('.shopping-cart-widget'))
                .removeClass('open');
        });

        // My Account menu button
        $('.my-account-button').on('click', function (event) {
            event.preventDefault();

            const dropdown = $(this).closest('.my-account-widget');

            if (dropdown.is('.open')) {
                dropdown.removeClass('open');
            } else {
                dropdown.addClass('open');
            }
        });

        $(document).on('click', function (event) {
            $('.my-account-widget')
                .not($(event.target).closest('.my-account-widget'))
                .removeClass('open');
        });

        // Newsletter Modal
        setTimeout(function () {
            if (storage.getItem('modal_stop') !== 'true') {
                $('#newsletterModal').modal('show');
            }
        }, $('#newsletterModal').data('time'));

        $('#dont-show').on('click', function () {
            if ($(this).is(":checked")) {
                storage.setItem('modal_stop', true);
            }
        });

        $('#dont-show-hour').on('click', function () {
            storage.setItem('modal_stop', true);
        });

        //Mobile Nav Hide Show
        if ($('.off-canvas-menu').length) {

            var mobileMenuContent = $('.desktop-menu nav ul').html();

            $('.off-canvas-menu .navigation').append(mobileMenuContent);

            //Menu Toggle Btn
            $('.mobile-nav-toggler').on('click', function () {
                $('body').addClass('off-canvas-menu-visible');
            });

            //Menu Toggle Btn
            $('.off-canvas-menu .menu-backdrop,.off-canvas-menu .close-btn').on('click', function () {
                $('body').removeClass('off-canvas-menu-visible');
            });
        }

        $('.off-canvas-menu li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fa fa-angle-down"></span></div>');
        $('.off-canvas-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
            $(this).prev('ul').slideToggle(500);
        });

        // Wishlist share icon update
        $('.yith-wcwl-share .share-button i.fa').addClass('fab').removeClass('fa');
        $('.single-product .yith-wcwl-icon.fa-heart-o').addClass('fa-heart').removeClass('fa-heart-o');

        //Back to top
        $(window).on('scroll', function () {
            if ($(this).scrollTop() >= 700) {
                $('#backtotop').fadeIn(500);
            } else {
                $('#backtotop').fadeOut(500);
            }
        });

        $('#backtotop').on('click', function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
        });


        // AJAX Search
        $(document).on('mouseup', function (e) {

            var searchresuls = $(".sidebar-search");

            // if the target of the click isn't the container nor a descendant of the container
            if (!searchresuls.is(e.target) && searchresuls.has(e.target).length === 0) {
                $("#datafetch").hide();
            }
        });

        // AJAX Search
        var datafetch = $("#datafetch");
        $('#keyword').on('keyup', function (event) {
            var keywordInput = this;
            var currentVal = keywordInput.value;
            var icon = $(keywordInput).next('.btn').find('i');
            icon.removeClass('fa-search')
                .addClass('fa-spinner fa-spin');

            $.ajax({
                url: searchAjaxUrlObj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'nxlx_ajax_search',
                    keyword: currentVal
                },
                success: function (data) {
                    if (currentVal.length !== 0 && data.length > 0) {
                        datafetch.html(data);
                        datafetch.show();
                    } else {
                        datafetch.html('');
                    }

                    icon.removeClass('fa-spinner fa-spin')
                        .addClass('fa-search');
                }
            });

        });

        // magnificPopup ajax view
        $(document).on('click', '.ajax-quick-view-popup', function (event) {
            event.preventDefault();
            let icon = $(this);

            $('.ajax-quick-view-popup i').removeClass('fa-search-plus').addClass('fa-spinner fa-spin');

            let modalId = 'QuickViewModal';
            let newmodal = makeShowModal(modalId, icon.attr('data-product-title'), icon.attr('data-product-link'));
            let loadTimeout;
            let percentComplete = 20;

            loadTimeout = setTimeout(updatePercent, 250)

            $.ajax({
                url: searchAjaxUrlObj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'nxlx_ajax_quick_view',
                    productid: $(this).attr('data-product-id')
                },
                success: function (data) {
                    loadTimeout = null;
                    newmodal.find('.modal-body').html(data);

                    $('.ajax-quick-view-popup i').removeClass('fa-spinner fa-spin').addClass('fa-search-plus');
                }
            });

            function updatePercent() {
                newmodal.find('.progress-bar').css({width: percentComplete + "%"})
                if (percentComplete !== 100) {
                    percentComplete += 20;
                    loadTimeout = setTimeout(updatePercent, 250)
                }
            }

        });

        //Navbar Fixed
        $(window).on('scroll', function () {
            if ($(document).scrollTop() > 80) {
                $('.sticky-header,.off-canvas-menu-bar').addClass('fixed-top');
            } else {
                $('.sticky-header,.off-canvas-menu-bar').removeClass('fixed-top');
            }
        });


        // AJAX Select Search One
        $('.nxlx-select-search #select-one').on('change', function (event) {
            $('.nxlx-select-search #select-two').prop("disabled", true);
            $.ajax({
                url: searchAjaxUrlObj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'nxlx_products_select_one_search',
                    product_id: $(this).find(':selected').data('id')
                },
                success: function (data) {
                    $('.nxlx-select-search #select-two').html(data);
                    $('.nxlx-select-search #select-two').removeAttr("disabled");
                },
                error: function (error) {
                    console.log(error);
                }
            });

        });

        // AJAX Select Search Two
        $('.nxlx-select-search #select-two').on('change', function (event) {
            $('.nxlx-select-search #select-three').prop("disabled", true);
            $.ajax({
                url: searchAjaxUrlObj.ajaxurl,
                type: 'POST',
                data: {
                    action: 'nxlx_products_select_two_search',
                    product_id: $(this).find(':selected').data('id')
                },
                success: function (data) {
                    $('.nxlx-select-search #select-three').html(data);
                    $('.nxlx-select-search #select-three').removeAttr("disabled");
                },
                error: function (error) {
                    console.log(error);
                }
            });

        });

        var slickOpts = {
            arrows: true,
            infinite: true,
            //lazyload: 'ondemand',
            //mobileFirst: true,
            "slidesToShow": 3,
            "slidesToScroll": 3,
            "responsive": [
                {
                    "breakpoint": 1200,
                    "settings": {
                        "slidesToShow": 3,
                        "slidesToScroll": 3
                    }
                },
                {
                    "breakpoint": 1024,
                    "settings": {
                        "slidesToShow": 2,
                        "slidesToScroll": 2
                    }
                },
                {
                    "breakpoint": 800,
                    "settings": "unslick"
                }
            ],
            nextArrow: '<i class="fas fa-chevron-right"></i>',
            prevArrow: '<i class="fas fa-chevron-left"></i>'
        }

        // product items
        $('.product-items').slick(slickOpts);

        // product up sells
        $('.up-sells.upsells.products .row').slick(slickOpts);

        // related product
        $('.related.products .row').slick(slickOpts);

        // product cross sells
        $('.cross-sells .row').slick(slickOpts);


        // product items tab
        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            $('.product-items').slick('setPosition');
        });

        // testimonial
        $('.testimonials').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.testimonials-nav'
        });

        $('.testimonials-nav').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.testimonials',
            dots: false,
            prevArrow: '<button type="button" class="slick-prev btn btn-sm btn-primary"><i class="fas fa-arrow-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-sm btn-primary"><i class="fas fa-arrow-right"></i></button>',
            centerMode: false,
            focusOnSelect: true
        });
    })
})(jQuery);


function makeShowModal(modalId = 'MyModal', heading = '', link = '') {
    var html = `
    <div class="modal fade" id="${modalId}" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <a href="${link}">
                        <h3 class="modal-heading">${heading}</h3>
                    </a>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="progress" style="height: 25px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-secondary" role="progressbar" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `;

    document.body.innerHTML += html;

    var newmodal = jQuery(`#${modalId}`);
    newmodal.modal();
    newmodal.modal('show');

    newmodal.on('hidden.bs.modal', function (e) {
        newmodal.remove();
    });

    return newmodal;
}

// Custom Select
var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "nxlx-custom-select":*/
x = document.getElementsByClassName("nxlx-custom-select");
l = x.length;
for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}

function closeAllSelect(elmnt) {
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);
